import React from 'react';
import { Typography, Switch, Grid, IconButton } from '@mui/material';
import { FilterSelective, Icons } from 'components';
import useCustomHook from './hooks';

const status = [
  {
    label: 'همه',
    value: '',
  },
  {
    label: 'فعال',
    value: 'true',
  },
  {
    label: 'غیرفعال',
    value: 'false',
  },
];

const columns = (onChangeStatus = () => { }, showAllowedProducts = () => { }, actionsList) => [
  {
    title: 'ردیف',
    field: 'num',
    cellStyle: {
      width: '1%',
    },
    filtering: false,
    sorting: false,
  },
  {
    title: 'شناسه کارگزار',
    field: 'id',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  {
    title: 'نام کارگزار',
    field: 'name',
    align: 'center',
    filtering: false,
    sorting: false,
  },
  ...(actionsList['toggleListDealerBtn'] ? [{
    title: 'وضعیت',
    field: 'enable',
    align: 'center',
    sorting: false,
    filterComponent: (props) => (
      <FilterSelective
        options={status}
        size="small"
        {...props}
        style={{ ...props.style, width: '70%', margin: 'auto' }}
      />
    ),
    render: (rd) => <ToggleStatus rd={rd} onChangeStatus={onChangeStatus} />,
  }] : []),

  {
    title: 'مجوز فروش تمام محصولات',
    field: 'allProductAllow',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) =>
      rd.allProductAllow ? (
        <Icons icon='Accept' color='#8BC34A' size='25' />
      ) : (
        <Icons icon='CloseCircle' color='#F44336' size='25' />
      ),
  },
  ...(actionsList['productListDealerBtn'] ? [{
    title: 'لیست محصولات دارای مجوز',
    field: 'allowedProducts',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => (
      <IconButton onClick={() => showAllowedProducts(rd)} size="large">
        <Icons icon='productList' color='#ccc' size='25' />
      </IconButton>
    ),
  }] : []),

];

const ToggleStatus = ({ rd, onChangeStatus }) => {
  const { loading, setLoading } = useCustomHook();
  return (
    <Grid container alignItems="center" justifyContent="center" style={{ opacity: loading ? 0.4 : 1 }}>
      <Switch
        disabled={loading}
        color="primary"
        onChange={async () => {
          setLoading(true);
          await onChangeStatus(rd?.id, !rd?.enable);
          setLoading(false);
        }}
        checked={rd?.enable}
        className='iosSwitch'
      />
      <Typography>{rd?.enable ? 'فعال' : 'غیرفعال'}</Typography>
    </Grid>
  );
};

const colMap = {
  name: 'text',
  id: 'id',
  enable: 'showDisable',
};

export { columns, colMap };
